import(/* webpackMode: "eager" */ "/home/ignacio/Documents/REPOSITORY/WEBSITES/Apex-Experience/apex-next/app/[locale]/guided-adventures/water-skiing/page.tsx");
